<ui-toolbar class="default">
    <!-- Toolbarul are 3 zone, stanga, centru si dreapta, pentru aliniere corecta orice element adaugat nou, trebuie sa intre intr-una din aceste zone -->
    <div class="toolbar-content left">
        <button ui-button id="btn_1602681683" [iconMid]="burgerIcon" *ngIf="sidenavToggle" (click)="toggleAppSideNav()"></button>

        <div class="header-campaign pointer"
            *ngIf="offersService.showOffersCampaign() && !this.currentLocationIsOffers"
            (click)="goToOffers(this.valuesService.offersCampaign.headerEntry.cta.icid)">
            <ui-icon *ngIf="valuesService.offersCampaign.headerEntry.icon"
                [type]="valuesService.offersCampaign.headerEntry.icon.type"
                [icon]="valuesService.offersCampaign.headerEntry.icon.name"
                class="mr-1"></ui-icon>
            <img *ngIf="valuesService.offersCampaign.headerEntry.image" [src]="valuesService.offersCampaign.headerEntry.image" alt="" class="text-middle"/>
            <span class="d-none d-md-initial medium mx-1">{{valuesService.offersCampaign.headerEntry.label | translate}}</span>
            <button ui-button
                [model]="valuesService.offersCampaign.headerEntry.cta.model"
                [color]="valuesService.offersCampaign.headerEntry.cta.color"
                [size]="valuesService.offersCampaign.headerEntry.cta.size"
                class="ml-1">
                {{valuesService.offersCampaign.headerEntry.cta.label | translate}}
            </button>
        </div>
        <ui-alert *ngIf="showPaymentMethodUpdateBanner" class="update-payment-banner p-0">
            <div class="d-flex align-items-center">
                <ui-icon type="feedback" icon="attention" shape="circle" size="24" bg="a8" color="dark" class="mr-1"></ui-icon>
                <div>
                    <p class="c1 strong">{{'update.payment.method.banner.title' | translate}}</p>
                    <p class="c1">{{'update.payment.method.banner.descriprion' | translate}}</p>
                </div>
                <button ui-button id="btn_1739358088" (click)='openPaymentModal()' model="solid" size="md" color="primary" class="ml-1">{{'update.payment.method.banner.add.now' | translate}}</button>
            </div>
        </ui-alert>
    </div>
    <!-- removed for PWA -->
    <div class="toolbar-content center" *ngIf="!getPwaActiveFunction()">
        <ui-logo
            [defaultLogo]="valuesService.centralLogos.app"
            class="toolbar-logo color-inherit d-none d-md-flex d-md-none align-items-center justify-content-center">
        </ui-logo>
    </div>

    <div class="toolbar-content right">
        <ui-tag *ngIf="appVersion && !deviceDetectorService.isDesktop()"
            [type]="'filled'"
            [color]="appVersion.color"
            [tooltip]="appVersion.tooltip?.textKey | translate: appVersion.tooltip.placeholders"
            [tooltipColor]="'secondary'"
            class="app-version medium uppercase color-dark">
                {{appVersion.label}}
        </ui-tag>

        <ui-popover *ngIf="showContextPopover && bubbleText"
            direction="bottom"
            alignment="end"
            width="300"
            [open]="showContextPopover"
            class="context-popover">
            <div popover-trigger>
                <ng-container *ngTemplateOutlet="userDrawerTrigger;"></ng-container>
            </div>
            <div popover-content class="d-flex align-items-center text-left">
                <ui-icon type="general" icon="chevrons-down" shape="svg" size="32" class="mr-12 animated-chevrons"></ui-icon>
                <p class="m-0">
                    <span class="d-block">{{bubbleText.firstDescription | translate}}</span>
                    <span class="d-block">{{bubbleText.secondDescription | translate}}</span>
                </p>
            </div>
        </ui-popover>

        <ng-container *ngIf="!showContextPopover">
            <ng-container *ngTemplateOutlet="userDrawerTrigger;"></ng-container>
        </ng-container>

        <button id="i_1573200575" ui-button icon *ngIf="configService.getNotifications()" (click)="toggleAppDrawerNotif()" class="px-1" [attr.aria-label]="'notification.main.title' | translate">
            <span class="icon connect_icon_notification"></span>
            <span *ngIf="notificationsCount > 0"
                class="badge circle danger top right">{{ notificationsCount <= valuesService.notificationsMaxCounter ? notificationsCount : ('notification.overOneThousand' | translate) }}</span>
        </button>
    </div>
</ui-toolbar>

<connection-status *ngIf="serviceWorkerHelperService.showServiceWorkerBannerInHeader()"
    [broken]="serviceWorkerHelperService.brokenServiceWorker()"
    [offline]="handleUnrecoverableStateService.thereAreConnectivityProblems()"
    [newVersion]="serviceWorkerHelperService.newVersion()"
    bg="bg-a8-10">
</connection-status>

<ng-template #userDrawerTrigger>
    <button ui-button id="btn_1602656141" (click)="toggleAppDrawerUser()" [ellipsis]="true">
        <div class="d-inline-flex user-info mr-8">
            <span class="mr-8" *ngIf="contextInterface">
                {{contextInterface.groupLabel !== '' ? (contextInterface.groupLabel | truncateText: 30) : (contextInterface.contextLabel | translate) }}
                &bull;
            </span>
            <span [innerHTML]="owner.firstname | truncateText: 30"></span>
        </div>
        <ui-avatar [avatar]="owner?.profile_pic" [name]="owner?.firstname" size="32" bg="light" color="dark"></ui-avatar>
        <ui-icon type="general" [icon]="localUserDetailsNavStatus ? 'chevron-up' : 'chevron-down'" class="ml-1" *ngIf="noGroups"></ui-icon>
    </button>
</ng-template>